import * as React from "react";
import * as TooltipPrimitive from "@radix-ui/react-tooltip";

import { cn } from "@/core/lib/utils";

const TooltipProvider = TooltipPrimitive.Provider;

const Tooltip = TooltipPrimitive.Root;

const TooltipTrigger = TooltipPrimitive.Trigger;

const TooltipContent = React.forwardRef<
  React.ElementRef<typeof TooltipPrimitive.Content>,
  React.ComponentPropsWithoutRef<typeof TooltipPrimitive.Content> & {
    align?: "end" | "start" | "center";
  }
>(({ className, sideOffset = 4, align = "center", ...props }, ref) => (
  <TooltipPrimitive.Content
    align={align}
    ref={ref}
    sideOffset={sideOffset}
    className={cn(
      // `!min-w-0`: sobrescreve o `min-width: 190px` que `global.css` aplica a todo popper do
      // Radix (pensado para dropdowns/menus, fora de qualquer @layer — por ordem de cascata
      // vence até de classes utilitárias comuns, daqui o `!important`). Numa tooltip curta
      // como "Baixar boleto" isso deixava espaço vazio em vez de abraçar o texto.
      "z-50 !min-w-0 w-max overflow-hidden rounded-md border border-neutral-200 bg-white px-3 py-1.5 text-sm text-neutral-500 shadow-md animate-in fade-in-0 zoom-in-95 data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2",
      className,
    )}
    {...props}
  />
));
TooltipContent.displayName = TooltipPrimitive.Content.displayName;

export { Tooltip, TooltipTrigger, TooltipContent, TooltipProvider };
